import React from 'react';
import styled from 'styled-components';
import Component from './component';

const PreviewCompany = ({ field = 'company.name', ...props }) => (
  <Component
    field={field}
    Element="div"
    {...props}
  />
);

export default styled(PreviewCompany)`
  display: block;
  margin-top: 0.5rem;
  font-size: 80%;
`;
